export default {
  path: "/SectionContent/Narrative",
  name: "Narrative",
  htmlContent: "Narrative.html",
  headings: [{ id: "n93Narrative", text: "93. Narrative ", type: "field" }],
};
